import { Icons } from '@/assets';
import React, { useEffect } from 'react';
import { ReactSVG } from 'react-svg';
import styles from './pageContainer.module.css';
import { useHistory, useLocation } from 'react-router-dom';
import { removeNoScroll } from '@/actions/Helper';

export default ({
  title,
  children,
  tabs,
  setTabs,
  setFix,
  mainPage,
  basePath = '',
  page,
  setPage,
  minWidth,
  rightContent,
  stretchHeaderToScrollWidth,
}) => {
  const [shouldStretchHeader, setShouldStretchHeader] = React.useState(false);

  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    // Only apply stretchHeaderToScrollWidth on larger screens to prevent horizontal scroll on small devices
    const updateStretchHeader = () => {
      setShouldStretchHeader(
        stretchHeaderToScrollWidth && window.innerWidth <= 768
      );
    };

    updateStretchHeader();
    window.addEventListener('resize', updateStretchHeader);

    return () => window.removeEventListener('resize', updateStretchHeader);
  }, [stretchHeaderToScrollWidth]);

  const currentPath = location.pathname;
  const currentForInventoryEmptyAll = currentPath.includes(
    '/inventory/emptyAll'
  );
  const currentForInventoryEmptyDropped = currentPath.includes(
    '/inventory/emptyDropped'
  );
  const currentForAppointments = currentPath.includes('/appointment');
  const currentForAutobook = currentPath.includes('/autobook');
  const currentForSearchDetail = currentPath.includes('/search-detail');

  const handleBack = () => {
    if (currentForInventoryEmptyAll) {
      history.push('/inventory/empty/all');
    } else if (currentForInventoryEmptyDropped) {
      history.push('/inventory/empty/dropped');
    } else if (currentForAppointments) {
      history.goBack();
    } else if (currentForAutobook) {
      history.push('/autobook');
    } else if (currentForSearchDetail) {
      history.push('/search');
    } else {
      const currentPath = location.pathname;
      const parentPath = currentPath.split('/').slice(0, -1).join('/');
      history.push(parentPath || '/');
    }
  };

  useEffect(() => {
    removeNoScroll();
  }, []);

  useEffect(() => {
    if (!setFix) return;

    const handleScroll = () => {
      if (window.scrollY > page * 200) {
        setPage(page + 1);
      }
      if (window.scrollY > 168) {
        setFix(true);
      } else {
        setFix(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [page]);

  const handleTabClick = (index) => {
    setTabs((prevTabs) =>
      prevTabs.map((t, i) => ({
        ...t,
        active: i === index,
      }))
    );

    const selectedTab = tabs[index];
    if (selectedTab?.path !== undefined) {
      const fullPath = history.push(selectedTab.path);
      // const fullPath = `${basePath}/${selectedTab.path}`.replace(/\/+$/, '');
      history.push(fullPath);
    }
  };

  return (
    <div
      id="page-container-ab"
      className={styles.container}
      style={{ minWidth: minWidth || '1266px' }}>
      <div className={shouldStretchHeader ? styles.content : ''}>
        <div className={styles.headerContainer}>
          <span className={styles.title}>{title}</span>
          {rightContent && rightContent}
          {!mainPage && (
            <div className={styles.backBtn} onClick={handleBack}>
              <ReactSVG src={Icons.arrowBack} className={styles.arrowBack} />{' '}
              Back
            </div>
          )}
        </div>

        {tabs && (
          <div className={styles.tabLinks}>
            {tabs.map((tab, index) => (
              <span
                key={index}
                onClick={() => handleTabClick(index)}
                className={
                  tab.active ? styles.tabLinksBtnActive : styles.tabLinksBtn
                }>
                {tab.name}
              </span>
            ))}
          </div>
        )}

        {children}
      </div>
    </div>
  );
};
